// Load Google's official 'web-vitals' library
var script = document.createElement('script');
script.src = 'https://unpkg.com/web-vitals@3/dist/web-vitals.iife.js';

script.onload = function() {
    console.clear();
    console.log("%c 🕵️ LIVE CORE WEB VITALS INSPECTOR ", "background: #222; color: #00e5ff; font-size: 16px; padding: 10px;");
    console.log("Interact with the page to see which elements are failing...");

    function logMetric(name, value, rating) {
        let color = rating === 'good' ? '#0cce6b' : (rating === 'needs-improvement' ? '#ffa400' : '#ff4e42');
        console.log(
            `%c ${name}: ${value} `, 
            `color: white; background: ${color}; font-size: 14px; padding: 4px; border-radius: 4px; font-weight: bold;`
        );
    }

    // 1. CHECK LCP (Largest Contentful Paint)
    webVitals.onLCP((metric) => {
        logMetric("LCP (Loading)", (metric.value / 1000).toFixed(2) + "s", metric.rating);
        
        // Find the LCP Element
        if (metric.entries.length > 0) {
            const lastEntry = metric.entries[metric.entries.length - 1];
            console.groupCollapsed("📸 View LCP Image/Element");
            console.log("This element determines your load speed:");
            console.log(lastEntry.element); // Hover this in console!
            console.groupEnd();
        }
    });

    // 2. CHECK CLS (Cumulative Layout Shift)
    webVitals.onCLS((metric) => {
        logMetric("CLS (Visual Stability)", metric.value.toFixed(3), metric.rating);
        
        // Find the Shifting Elements
        if (metric.entries.length > 0) {
            console.groupCollapsed("💃 View Shifting Elements");
            metric.entries.forEach(entry => {
                if (!entry.sources) return;
                entry.sources.forEach(source => {
                    console.log("Moved by:", source.node); // Hover this in console!
                    console.log("Shift Amount:", (entry.value).toFixed(4));
                });
            });
            console.groupEnd();
        }
    });

    // 3. CHECK INP (Interaction to Next Paint)
    webVitals.onINP((metric) => {
        logMetric("INP (Click Delay)", metric.value.toFixed(0) + "ms", metric.rating);
        
        // Find the Slow Button
        if (metric.entries.length > 0) {
            // The interaction that caused the delay
            const target = metric.entries[0].target; 
            console.group("🛑 View Slow Button");
            console.log("You clicked this:", target); // Hover this in console!
            console.log("Processing Time:", metric.entries[0].processingDuration.toFixed(0) + "ms");
            console.groupEnd();
        }
    });
    
    console.log("👉 Waiting... (Scroll, Click, or Type to see which elements are slow)");
};

document.head.appendChild(script);